export const json = {
  "title": "Derbyshire Capture",
  "logoPosition": "right",
  "pages": [
    {
      "name": "page1",
      "elements": [
        {
          "type": "panel",
          "name": "panel5",
          "showQuestionNumbers": "off",
          "elements": [
            {
              "type": "html",
              "name": "question40",
              "html": "<h3>Important Information</h3>\nClose pass reports - Whilst all close pass reports from cyclists and horse riders will continue to be reviewed, to remain efficient, effective and comply with national guidance regarding the analysis of video evidence, reports of close passes will only result in a positive outcome, including warning letters, in exceptional circumstances.\n<hr>\n<h5 style=\"font-weight:400;\">Please make sure you have read the Frequently Asked Questions for help and guidance when completing this form.&nbsp;</h5>\n<p><a style=\"color:#253746;\" target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://www.derbyshire.police.uk/police-forces/derbyshire-constabulary/areas/derbyshire-force-content/campaigns/campaigns/2019/derbyshire-capture/\"><strong>Link to FAQ's</strong></a>"
            },
            {
              "type": "checkbox",
              "name": "FAQ",
              "title": "I have read the frequently asked questions",
              "isRequired": true,
              "choices": [
                {
                  "value": "Item 1",
                  "text": "Yes"
                }
              ]
            },
            {
              "type": "radiogroup",
              "name": "courtAttendance",
              "visibleIf": "{FAQ} allof ['Item 1']",
              "title": "Court Attendance - Please consider your decision carefully before continuing with the submission after reading the FAQ’s regarding appearing at court.",
              "description": "If an offence is identified and you are not willing to attend court, the submission will likely result in non-formal action such as a warning letter. It is extremely unlikely we will be able to take any formal action if you are not willing to attend court should your attendance be required due to evidential requirements. In rare cases where for operational reasons we consider an incident so serious that we must act and you are not willing to attend court, we may decide to progress the matter formally and you may be required to attend court despite your preference.  ",
              "isRequired": true,
              "choices": [
                "I am willing to attend Court and give evidence in relation to this matter.",
                "I am not willing to attend Court and give evidence in relation to this matter."
              ]
            },
            {
              "type": "checkbox",
              "name": "statementValidation",
              "visibleIf": "{FAQ} allof ['Item 1']",
              "title": "Statement",
              "isRequired": true,
              "choices": [
                "All statements associated with an offence or prosecution will be retained in line with the police forces retention policies. If your submission is not progressed the original copy of your statement and associated files will be deleted"
              ]
            },
            {
              "type": "html",
              "name": "statement",
              "visibleIf": "{FAQ} allof ['Item 1']",
              "html": "<p>We are not able to discuss individual submissions and re-submissions for which we have already provided an update will not be processed.</p>"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel1",
          "visibleIf": "{statementValidation} allof ['All statements associated with an offence or prosecution will be retained in line with the police forces retention policies. If your submission is not progressed the original copy of your statement and associated files will be deleted'] and {courtAttendance} notempty",
          "elements": [
            {
              "type": "html",
              "name": "question3",
              "html": "<h3> Your Details </h3>\n<hr>"
            },
            {
              "type": "text",
              "name": "FirstName",
              "title": "First Name",
              "maxLength": 100,
              "isRequired": true
            },
            {
              "type": "text",
              "name": "LastName",
              "startWithNewLine": false,
              "title": "Last Name",
              "maxLength": 100,
              "isRequired": true
            },
            {
              "type": "text",
              "name": "DOB",
              "startWithNewLine": false,
              "title": "Date of birth - Please either choose from the picker or type in the given format",
              "isRequired": true,
              "min": "1900-01-01",
              "inputType": "date"
            },
            {
              "type": "text",
              "name": "AddLine1",
              "title": "Address Line 1",
              "maxLength": 100,
              "isRequired": true
            },
            {
              "type": "text",
              "name": "AddLine2",
              "startWithNewLine": false,
              "maxLength": 100,
              "title": "Address Line 2"
              
            },
            {
              "type": "text",
              "name": "TownCity",
              "title": "Town/City",
              "maxLength": 100,
              "isRequired": true
            },
            {
              "type": "text",
              "name": "County",
              "startWithNewLine": false,
              "maxLength": 100,
              "title": "County"
            },
            {
              "type": "text",
              "name": "Postcode",
              "startWithNewLine": false,
              "title": "Postcode",
              "maxLength": 10,
              "isRequired": true
            },
            {
              "type": "text",
              "name": "ContactEmail",
              "title": "Contact Email Address",
              "maxLength": 100,
              "isRequired": true,
              "inputType": "email"
            },
            {
              "type": "text",
              "name": "ContactTel",
              "title": "Contact Tel Number",
              "maxLength": 100,
              "isRequired": true,
              "inputType": "tel"
            },
            {
              "type": "text",
              "name": "AltContactTel",
              "startWithNewLine": false,
              "title": "Alternate Tel Number",
              "maxLength": 20,
              "inputType": "tel"
            },
            {
              "type": "dropdown",
              "name": "PreferredContact",
              "title": "Pref Means of Contact",
              "isRequired": true,
              "choices": [
                {
                  "value": "Writing",
                  "text": "Writing"
                },
                {
                  "value": "Email",
                  "text": "Email"
                },
                {
                  "value": "Telephone",
                  "text": "Telephone"
                },
                {
                  "value": "Alternative Telephone",
                  "text": "Alternative Telephone"
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel2",
          "visibleIf": "{AddLine1} notempty and {ContactTel} notempty and {DOB} notempty and {PreferredContact} anyof ['Writing', 'Email', 'Telephone', 'Alternative Telephone']",
          "elements": [
            {
              "type": "html",
              "name": "question38",
              "html": "<h3> Statement </h3>\n<hr>"
            },
            {
              "type": "text",
              "name": "IncidentRoadLocation",
              "title": "Location of Incident",
              "isRequired": true,
              "maxLength": 300,
               "description": "Please enter the location in as much detail as possible. Include Road Name and Town / City / Area",
              "placeholder": "Enter as much detail as possible. Include Road Name & Town / City / Area"
            },
            {
              "type": "text",
              "name": "What3wordsLocation",
              "startWithNewLine": false,
              "title": "what3words Location of Incident",
              "maxLength": 100,
              "isRequired": true,
               "description": "Please visit https://what3words.com/ and select the square closest and enter the 3 words here",
               "placeholder": "e.g ///connector.unguarded.pronouns"
            },
            {
              "type": "text",
              "name": "IncidentDateTime",
              "title": "Date & Time of incident",
              "isRequired": true,
              "min": "2024-01-01T00:00",
              "inputType": "datetime-local"
            },
            {
              "type": "boolean",
              "name": "PartiesKnown",
              "title": "Do you know any of the parties involved?",
              "isRequired": true
            },
            {
              "type": "comment",
              "name": "PartiesKnownDetails",
              "visibleIf": "{PartiesKnown} = true",
              "maxLength": 300,
              "title": "Please provide details of the parties involved",
              "requiredIf": "{PartiesKnown} = true"
            },
            {
              "type": "text",
              "name": "OffendingReg",
              "maxLength": 50,
              "title": "Registration of offending vehicle",
              "isRequired": true
            },
            {
              "type": "text",
              "name": "OffendingColor",
              "maxLength": 50,
              "startWithNewLine": false,
              "title": "Color of offending vehicle (If known)"
            },
            {
              "type": "text",
              "name": "OffendingMake",
              "maxLength": 50,
              "title": "Make of offending vehicle (If known)"
            },
            {
              "type": "text",
              "name": "OffendingModel",
              "startWithNewLine": false,
              "maxLength": 50,
              "title": "Model of offending vehicle (If known)"
            },
            {
              "type": "dropdown",
              "name": "TypeOfSubmitter",
              "title": "You are the:",
              "isRequired": true,
              "choices": [
                {
                  "value": "Vehicle driver",
                  "text": "Vehicle driver"
                },
                {
                  "value": "Vehicle passenger",
                  "text": "Vehicle passenger"
                },
                {
                  "value": "Motorcyclist",
                  "text": "Motorcyclist"
                },
                {
                  "value": "Cyclist",
                  "text": "Cyclist"
                },
                {
                  "value": "Horse Rider",
                  "text": "Horse Rider"
                },
                {
                  "value": "Pedestrian",
                  "text": "Pedestrian"
                }
              ]
            },
            {
              "type": "text",
              "name": "MyReg",
              "visibleIf": "{TypeOfSubmitter} = 'Vehicle driver' or {TypeOfSubmitter} = 'Motorcyclist'",
              "title": "Registration of your vehicle",
              "maxLength": 50,
              "requiredIf": "{TypeOfSubmitter} = 'Vehicle driver' or {TypeOfSubmitter} = 'Motorcyclist'"
            },
            {
              "type": "text",
              "name": "MyColor",
              "visibleIf": "{TypeOfSubmitter} = 'Vehicle driver' or {TypeOfSubmitter} = 'Motorcyclist'",
              "startWithNewLine": false,
              "maxLength": 50,
              "title": "Color of your vehicle"
            },
            {
              "type": "text",
              "name": "MyMake",
              "maxLength": 50,
              "visibleIf": "{TypeOfSubmitter} = 'Vehicle driver' or {TypeOfSubmitter} = 'Motorcyclist'",
              "title": "Make of your vehicle"
            },
            {
              "type": "text",
              "name": "MyModel",
              "maxLength": 50,
              "visibleIf": "{TypeOfSubmitter} = 'Vehicle driver' or {TypeOfSubmitter} = 'Motorcyclist'",
              "startWithNewLine": false,
              "title": "Model of your vehicle"
            },
            {
              "type": "comment",
              "name": "MyVehDetails",
              "maxLength": 50,
              "visibleIf": "{TypeOfSubmitter} = 'Vehicle passenger'",
              "title": "Details of the vehicle you were in",
              "requiredIf": "{TypeOfSubmitter} = 'Vehicle passenger'"
            },
            {
              "type": "boolean",
              "name": "WearingReflective",
              "visibleIf": "{TypeOfSubmitter} = 'Cyclist'",
              "title": "Were you wearing reflective clothing?",
              "requiredIf": "{TypeOfSubmitter} = 'Cyclist'"
            },
            {
              "type": "radiogroup",
              "name": "LightsOn",
              "visibleIf": "{TypeOfSubmitter} = 'Cyclist'",
              "title": "Did you have your lights on?",
              "requiredIf": "{TypeOfSubmitter} = 'Cyclist'",
              "choices": [
                {
                  "value": "Yes",
                  "text": "Yes"
                },
                {
                  "value": "No",
                  "text": "No"
                },
                {
                  "value": "Not required (EG daytime)",
                  "text": "Not required (EG daytime)"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "selfOrHorseReflective",
              "visibleIf": "{TypeOfSubmitter} = 'Horse Rider'",
              "title": "Were you or the horse wearing reflective clothing?",
              "requiredIf": "{TypeOfSubmitter} = 'Horse Rider'"
            },
            {
              "type": "boolean",
              "name": "TimeDIff",
              "title": "Is the date/time displayed on the footage the same as the time at which you stated the incident happened?",
              "isRequired": true
            },
            {
              "type": "comment",
              "name": "TimeDiffReason",
              "visibleIf": "{TimeDIff} = false",
              "title": "If not, provide a reason for the time difference - including the correct time offset",
              "requiredIf": "{TimeDIff} = false"
            },
            {
              "type": "comment",
              "name": "submitterPosition",
              "maxLength": 1000,
              "title": "Where was the offending vehicle in relation to you when the driving incident took place?",
              "description": "e.g. \nThe vehicle was directly in front of me.\nThe vehicle was in front on me in the outside lane.\nThe vehicle was in front of me pulling out of a junction to my left/right.\nThe vehicle was traveling directly behind me in the outside lane.\nThe vehicle passed me on my left/right.\nThe vehicle passed me in the outside lane/in the opposite carriageway.",
              "isRequired": true
            },
            {
              "type": "comment",
              "name": "selfDescriptionOfInc",
              "maxLength": 3000,
              "title": "In your own words, describe what happened including as much detail as possible. This information will form the basis of a formal court document and should only contain information relevant to the incident.",
              "isRequired": true,
              "placeholder": "e.g. I was driving my car along the A6 South towards Derby. I was traveling in the inside lane when the offending vehicle approached really fast from behind me, then overtook me on a double white line. It was a raining and the roads were very wet and visibility was poor due to the rain and spray of the road. As the vehicle passed me it was very close to me and I thought it might hit my wing mirror. It pulled back in very close to the front of my vehicle and I thought it was going to clip the front of my car, in fact I had to brake to avoid a collision. The vehicle then drove away at speed and I didn’t see it again."
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel4",
          "visibleIf": "{IncidentRoadLocation} notempty and {OffendingReg} notempty and {IncidentDateTime} notempty",
          "elements": [
            {
              "type": "checkbox",
              "name": "finalValidation",
              "title": "Validation",
              "isRequired": true,
              "choices": [
                {
                  "value": "I confirm this statement is true to the best of my knowledge and belief and I make it knowing that if it is tendered in evidence I shall be liable to prosecution if I have wilfully stated in it anything which I know to be false, or do not believe to be true",
                  "text": "I confirm this statement is true to the best of my knowledge and belief and I make it knowing that if it is tendered in evidence I shall be liable to prosecution if I have wilfully stated in it anything which I know to be false, or do not believe to be true"
                }
              ]
            },
            {
              "type": "expression",
              "name": "defaultSubmitterName",
              "title": "Name",
              "expression": "displayValue('FirstName') + ' ' + displayValue('LastName')"
          }
          ,
            {
              "type": "expression",
              "name": "submissionDate",
              "startWithNewLine": false,
              "title": "Date",
              "expression": "currentDate()"
            }
           
          ]
        },
        
        {
          "type": "panel",
          "name": "captchaPanel",
          "elements": [
           
            
            {
              "type": "recaptcha",
              "name": "recaptcha",
              "title": "Please complete the ReCaptcha",
              "isRequired": true
            }
          ]
        }
      
      ]
    }
  ],
  "showTitle": false,
  "widthMode": "responsive"
}